
export function businessTargetTypeToPath (targetType) {
  let path = targetType;
  if (path === 'contractPlanFund') {
    path = 'plan-fund';
  } else if (path === 'contractFundRecord') {
    path = 'fund-record';
  } else if (path === 'contractInvoice') {
    path = 'invoice';
  } else if (path === 'purchaseApply') {
    path = 'procurement/apply';
  }
  return path;
}
